var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"min-height-100vh is-flex is-flex-direction-column is-align-items-center bg-white"},[_c('section',{staticClass:"is-flex-grow-1 full-width max-width-widescreen pb-6 px-5"},[_c('Navbar'),_c('router-view')],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }